var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-list"},[_c('h3',{staticClass:"category-list__title",domProps:{"innerHTML":_vm._s(_vm.$i18n('blog.categories'))}}),_vm._v(" "),_c('div',{staticClass:"category-list__chips"},_vm._l((_vm.categoryList),function(category,index){return _c('a',{key:`category-${index}`,class:[
        'category-list__chips-item flex items-center',
        {
          active: _vm.isCategorySelected(category),
        },
      ],attrs:{"href":`/blog/${category.slug ? category.slug + '/' : ''}`,"aria-label":`category-${index}`}},[_vm._v("\n      "+_vm._s(category.name)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }